import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueClipboard from 'vue-clipboard2'
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faLink,
  faEdit,
  faCheck,
  faCheckCircle,
  faTimes,
  faPlus,
  faMinus,
  faExternalLinkAlt,
  faHistory,
  faBullseye,
  faArrowLeft,
  faRedo,
  faDownload,
  faPen,
  faTrash,
  faImage
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { Auth0Plugin, getInstance } from '@/plugins/vue_auth'
import mixins from '@/mixins/global'
import { initializeAuth, resetAuth } from '@/utils/authInitializer'
import { InlineSvgPlugin } from 'vue-inline-svg'
import Urlbox from 'urlbox'
import Fragment from 'vue-fragment'
import * as Sentry from '@sentry/vue'
import Alert from '@/components/global/alert/Alert'

require('dotenv').config()

if (process.env.NODE_ENV !== 'development') {
  Sentry.init({
    Vue,
    dsn: process.env.VUE_APP_SENTRY_DSN,
    tracesSampleRate: 1.0,
    replaySessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
  })
}

Vue.config.productionTip = false
Vue.use(require('vue-moment'))
Vue.use(VueClipboard)
Vue.use(mixins)
Vue.use(InlineSvgPlugin)
Vue.use(Fragment.Plugin)

// Readiness and account data from a previous page load cannot authorize this one.
resetAuth(Vue)

Vue.use(Auth0Plugin, {
  domain: `${process.env.VUE_APP_AUTH0_DOMAIN}`,
  clientId: `${process.env.VUE_APP_AUTH0_CLIENT_ID}`,
  onRedirectCallback: async (state) => {
    try {
      await initializeAuth(Vue)
    } catch (error) {
      if (error.action === 'register') router.replace('/register').catch(() => {})
      return // App.vue presents the migration error and recovery action.
    }

    router.replace(
      state && state.targetUrl
        ? state.targetUrl
        : window.location.pathname
    ).catch(() => {})
  },
  cacheLocation: 'localstorage'
})

const authInstance = getInstance()
if (authInstance) {
  authInstance.$watch('loading', async (loading) => {
    if (!loading && authInstance.isAuthenticated) {
      try {
        await initializeAuth(Vue)
      } catch (error) {
        // App.vue presents the sanitized initialization error.
      }
    }
  }, { immediate: true })
}

const urlbox = Urlbox(process.env.VUE_APP_URL_BOX_API_PUBLIC_KEY, process.env.VUE_APP_URL_BOX_API_PRIVATE_KEY)

const createUrlBoxImage = async (url, options) => {
  if (url) {
    const imgUrl = urlbox.buildUrl({
      url: url,
      format: 'jpg',
      ...options
    })
    return imgUrl
  }
}

Vue.prototype.$urlbox = createUrlBoxImage
Vue.prototype.$axios = axios

library.add(
  faLink,
  faEdit,
  faCheck,
  faCheckCircle,
  faTimes,
  faPlus,
  faMinus,
  faExternalLinkAlt,
  faHistory,
  faBullseye,
  faArrowLeft,
  faRedo,
  faDownload,
  faPen,
  faTrash,
  faImage
)
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.component('alert', Alert)

new Vue({
  router,
  store,
  render: h => h(App),
  computed: {
    baseUrl () {
      return process.env.VUE_APP_BASE_URL
    }
  }
}).$mount('#app')
